import React, { useEffect, useMemo, useRef } from 'react';
import './AdSlot.css';

const ADS_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT_ID || '';
const ADS_TEST_MODE = process.env.REACT_APP_ADSENSE_TEST_MODE === 'true';

const ensureAdsScript = () => {
  if (!ADS_CLIENT || typeof document === 'undefined') {
    return false;
  }

  if (!document.querySelector(`script[data-ads-client="${ADS_CLIENT}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_CLIENT}`;
    script.crossOrigin = 'anonymous';
    script.dataset.adsClient = ADS_CLIENT;
    document.head.appendChild(script);
  }

  return true;
};

const AdSlot = ({ slot, format = 'auto', className = '', responsive = true, label = 'Publicidade' }) => {
  const adRef = useRef(null);
  const isEnabled = Boolean(ADS_CLIENT && slot);

  const classes = useMemo(() => {
    return `ad-slot ${className}`.trim();
  }, [className]);

  useEffect(() => {
    if (!isEnabled || !ensureAdsScript() || !adRef.current) {
      return;
    }

    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch (_) {
      // Ignore repeated push failures during local refresh/render churn.
    }
  }, [isEnabled, slot]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={classes} aria-label={label}>
      <span className="ad-slot-label">{label}</span>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADS_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? 'true' : 'false'}
        data-adtest={ADS_TEST_MODE ? 'on' : undefined}
      />
    </div>
  );
};

export default AdSlot;